export const isErrorEvent = (event: Event): event is ErrorEvent =>
  (event as ErrorEvent).message !== undefined;
